<div class="training-template-form">
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <dx-button
        *ngIf="!isViewMode"
        text="{{ 'COMMON.SAVE' | translate }}"
        type="normal"
        (click)="onFormSubmit()"
      ></dx-button>
      <dx-drop-down-button
        *ngIf="isViewMode"
        [splitButton]="true"
        [text]="'TRAINING-TEMPLATE.TITLE-EDIT' | translate"
        stylingMode="contained"
        type="normal"
        [dropDownOptions]="{ width: 230 }"
        (onButtonClick)="onEditClick()"
      >
        <dxi-item (click)="duplicateTemplate()">
          {{ "TRAINING-TEMPLATE.FORM.DUPLICATE" | translate }}
        </dxi-item>
         <dxi-item (click)="openDeleteTemplateConfirmationModal()">
          {{ "TRAINING-TEMPLATE.FORM.DELETE-TEMPLATE" | translate }}
        </dxi-item>
      </dx-drop-down-button>
    </div>
    <app-page-title
      [title]="
        isViewMode
          ? ('TRAINING-TEMPLATE.FORM.TRAINING-TEMPLATE' | translate)
          : editingTrainingTemplateId
          ? ('TRAINING-TEMPLATE.TITLE-EDIT' | translate)
          : ('TRAINING-TEMPLATE.TITLE-ADD' | translate)
      "
    ></app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="avatar-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="user-avatar"
              [src]="trainingTemplateForm.imageBase64"
              *ngIf="trainingTemplateForm.imageBase64"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!trainingTemplateForm.imageBase64"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onAvatarUploaded($event)"
            [readOnly]="isViewMode"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel
          class="training-template-panel"
          [title]="
            isViewMode
              ? ('TRAINING-TEMPLATE.FORM.TITLE-DESCRIPTION' | translate)
              : null
          "
        >
          <dx-form
            #descriptionForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="trainingTemplateForm"
            [readOnly]="isViewMode"
          >
            <dxi-item dataField="name">
              <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.TITLE-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{
                height: 100
              }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
    </div>
    <div>
      <app-panel>
        <dx-tabs
          width="100%"
          [selectedIndex]="selectedDescriptionTab"
          [showNavButtons]="false"
          [dataSource]="descriptionTabs"
          (onItemClick)="onDescriptionTabChange($event)"
        ></dx-tabs>
        <div
          *ngIf="selectedDescriptionTab == 0"
          class="training-template-description-wrapper"
        >
          <app-expandable-text-editor
            [readOnly]="isViewMode"
            [(value)]="trainingTemplateForm.descriptionExtended"
            [(isExpanded)]="isDescriptionExpanded"
          ></app-expandable-text-editor>
          <div 
            *ngIf="userContext.canUseTextTemplates"
            class="text-template-container"
          >
            <app-text-template-selector
              *ngIf="!isViewMode"
              [type]="descriptionTextTemplateType"
              [content]="trainingTemplateForm.descriptionExtended"
              (contentChange)="onExtendedDescriptionContentChanged($event)"
            ></app-text-template-selector>
          </div>
        </div>
        <div
          *ngIf="selectedDescriptionTab == 1"
          class="training-template-description-wrapper"
        >
          <app-expandable-text-editor
            [readOnly]="isViewMode"
            [(value)]="trainingTemplateForm.descriptionCertificate"
            [(isExpanded)]="isCertificateDescriptionExpanded"
            [fontFamily]="certificateFontFamily"
            [fontSize]="certificateFontSize"
          >
            <div editor-extra-actions class="extra-actions">
              <dx-button
                [text]="'COMMON.CERTIFICATE-PREVIEW' | translate"
                class="preview-button"
                (click)="showCertificatePreview()"
              ></dx-button>
            </div>
          </app-expandable-text-editor>
          <dx-form
            class="legal-footer"
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="trainingTemplateForm"
            [readOnly]="isViewMode"
          >
            <dxi-item itemType="group" colCount="2">
              <dxi-item *ngIf="!isViewMode">
                <div *dxTemplate>
                  <app-organisation-unit-footer-selector
                    [label]="'TRAINING-TEMPLATE.FORM.CHOOSE-LEGAL-FOOTER-LOCATION' | translate"
                    [data]="certificateOrganizationUnits"
                    [(value)]="trainingTemplateForm.certificateFooterLocationId">
                  </app-organisation-unit-footer-selector>
                </div>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </div>
      </app-panel>
    </div>
    <div>
      <app-panel
        [title]="'TRAINING-TEMPLATE.FORM.TRAINING-SETTINGS' | translate"
      >
        <dx-form
          #settingsForm
          labelMode="floating"
          [showColonAfterLabel]="false"
          [formData]="trainingTemplateForm"
          [readOnly]="isViewMode"
        >
          <dxi-item itemType="group">
            <dxo-col-count-by-screen
              [xs]="1"
              [sm]="1"
              [md]="1"
              [lg]="2"
            ></dxo-col-count-by-screen>
            <dxi-item
              itemType="group"
              [caption]="
                !isViewMode
                  ? ('TRAINING-TEMPLATE.FORM.GENERAL-SETTINGS' | translate)
                  : null
              "
            >
              <dxi-item *ngIf="!isExternalEvent">
                <dxo-label
                  [text]="'COMMON.FIELDS.TRAINERS' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="trainingTemplateForm.trainerIds"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMMON.FIELDS.TRAINERS' | translate"
                    [dataSource]="trainers"
                    [readOnly]="isViewMode"
                    labelMode="floating"
                    stylingMode="outlined"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="trainers"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onTrainerSelected($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
              <dxi-item
                [editorOptions]="trainingTypeOptions"
                dataField="trainingType"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.TRAINING-TYPE' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item *ngIf="trainingTemplateForm.trainingType === TrainingTypeModel.IDD">
                 <dxo-label
                  [text]="'COMMON.FIELDS.TRAINING-TIME' | translate"
                ></dxo-label>
                <div *dxTemplate>
                  <div>
                    <dx-validator
                      [adapter]="trainingTimeAdapter"
                      validationGroup="trainingTimeGroup"
                    >
                      <dxi-validation-rule
                        type="custom"
                        [validationCallback]="validateTrainingTime"
                        [message]="
                          'VALIDATIONS.TRAINING-TIME-MINUTE' | translate
                        "
                      ></dxi-validation-rule>
                      <dx-validation-summary></dx-validation-summary>
                    </dx-validator>
                    <div #timePicker>
                      <app-time-picker
                        [isInvalid]="!isTrainingTimeValid"
                        [label]="'COMMON.FIELDS.TRAINING-TIME' | translate"
                        [disabled]="isViewMode"
                        (timeChanged)="handleTimePicker($event)"
                        [defaultValue]="{
                          hours: trainingTemplateForm.iddHours!,
                          minutes: trainingTemplateForm.iddMinutes!
                        }"
                        [validationMessage]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
                      ></app-time-picker>
                    </div>
                  </div>
                </div>
              </dxi-item>
              <dxi-item 
                *ngIf="!isExternalEvent"
                dataField="maximumMembers" 
                editorType="dxNumberBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.MAXIMUM-PARTICIPANTS' | translate"
                ></dxo-label>
              </dxi-item>

              <dxi-item
                *ngIf="
                  trainingTemplateForm.trainingType === 0 && isWbdConfigured
                "
                [editorOptions]="learningTypeOptions"
                dataField="lernart"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.LEARNING-TYPE' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LEARNING-TYPE-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item
                *ngIf="
                  trainingTemplateForm.trainingType === 0 && isWbdConfigured
                "
                [editorOptions]="learningContentOptions"
                dataField="lerninhalt"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.LEARNING-CONTENT' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LEARNING-CONTENT-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dxi-item>
              <dxi-item *ngIf="!isExternalEvent">
                <div *dxTemplate>
                  <dx-drop-down-box
                    [(value)]="trainingTemplateForm.reminders"
                    [inputAttr]="{ 'aria-label': 'Owner' }"
                    [dataSource]="reminderOptions"
                    [label]="'COMMON.FIELDS.TRAINING-CONFIRMATION-AND-REMINDERS' | translate"
                    valueExpr="value"
                    displayExpr="label"
                    [readOnly]="isViewMode"
                    labelMode="floating"
                    stylingMode="outlined"
                    [showClearButton]="true"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="false"
                        [dataSource]="reminderOptions"
                        dataStructure="plain"
                        keyExpr="value"
                        displayExpr="label"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        [selectByClick]="true"
                        (onItemSelectionChanged)="onReminderSelectionChanged($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
              <dxi-item>
                <div *dxTemplate>
                  <hr>
                  <div class="publication-mode-container">
                    <app-publication-mode-selection
                      [mode]="trainingTemplateForm.publishingMode"
                      (modeChange)="onPublishingModeChanged($event)"
                      [isViewMode]="isViewMode"
                      [isPublishedToSubscribers]="isTenantPublishedToSubscribers"
                      [isPrivatePublishing]="isPrivatePublishing"
                    ></app-publication-mode-selection>
                  </div>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item>
              <div *dxTemplate>
                <app-event-publication-settings
                  [publishingMode]="trainingTemplateForm.publishingMode"
                  [isPublishedToSubscribers]="isTenantPublishedToSubscribers"
                  [isPrivatePublishing]="isPrivatePublishing"
                  [isViewMode]="isViewMode"
                  [personCount]="personCount"

                  [visibilityMode]="trainingTemplateForm.visibilityMode"
                  (visibilityModeChange)="onVisibilityModeChanged($event)"

                  [(selectedOrganizationUnitIds)]="selectedOrganizationUnitIds"

                  [allowSharingWithSubscribers]="trainingTemplateForm.allowSharingWithSubscribers"
                  (allowSharingWithSubscribersChange)="
                    onAllowSharingWithSubscribersChanged($event)
                  "

                  [(trainingGroupIds)]="trainingTemplateForm.trainingGroupIds"
                  [(trainingCategoryIds)]="trainingTemplateForm.trainingCategoryIds"
                  [(standardTrainingCategoryIds)]="trainingTemplateForm.standardTrainingCategoryIds"
                  [(roleIds)]="trainingTemplateForm.roleIds"
                  [(subscriptionIds)]="trainingTemplateForm.subscriptionIds"

                  [organizationUnits]="organizationUnits"
                  [trainingGroups]="trainingGroups"
                  [trainingCategories]="trainingCategories"
                  [standardTrainingCategories]="standardTrainingCategories"
                  [roles]="roles"
                  [subscribers]="subscribers"
                ></app-event-publication-settings>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
        <div class="checkboxes-row">
          <dx-form
            [colCountByScreen]="{ lg: 2, md: 1 }"
            [formData]="trainingTemplateForm"
            [showColonAfterLabel]="false"
            labelMode="static"
            labelLocation="left"
            [readOnly]="isViewMode"
          >
            <dxi-item
              *ngIf="!isExternalEvent"
              dataField="sendCertificateLink"
              editorType="dxCheckBox"
              [editorOptions]="{
                text: 'COMMON.FIELDS.CERTIFICATE-LINK-IN-COMPLETION-MAIL' | translate,
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item
              *ngIf="!isExternalEvent"
              dataField="sendFeedbackLink"
              editorType="dxCheckBox"
              [editorOptions]="{
                text: 'COMMON.FIELDS.FEEDBACK-LINK-IN-COMPLETION-MAIL' | translate,
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item
              *ngIf="!isExternalEvent"
              dataField="allowUnknownUsersToJoin"
              editorType="dxCheckBox"
              [editorOptions]="{
                text: 'COMMON.FIELDS.ALLOW-UNKNOWN-USERS-TO-JOIN' | translate,
                disabled: allowUnknownUsersToJoinDisabled
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
          </dx-form>
        </div>
      </app-panel>
    </div>
    <div>
      <app-panel
        class="training-template-location-panel"
        [title]="'COMMON.FIELDS.TRAINING-LOCATION' | translate"
      >
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <dx-form
              #locationForm
              [formData]="trainingTemplateForm"
              [showColonAfterLabel]="false"
              labelMode="floating"
              [readOnly]="isViewMode"
            >
              <dxi-item
                [editorOptions]="trainingLocationTypeOptions"
                dataField="trainingLocation.locationType"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.EVENT-TYPE' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="
                  trainingTemplateForm.trainingLocation &&
                  trainingTemplateForm.trainingLocation.locationType === TrainingLocationType.Address
                "
              >
                <div *dxTemplate>
                  <dx-autocomplete
                    [(text)]="googleSearchText"
                    [searchExpr]="autocompleteSearchFilter"
                    [label]="'COMMON.FIELDS.TRAINING-LOCATION' | translate"
                    labelMode="floating"
                    stylingMode="outlined"
                    [label]="
                      'TRAINING-TEMPLATE.FORM.SEARCH-TRAINING-LOCATION'
                        | translate
                    "
                    [dataSource]="googlePlaces"
                    valueExpr="description"
                    (onValueChanged)="getGooglePlaces($event)"
                    (onItemClick)="setLocationPlace($event)"
                    [readOnly]="isViewMode"
                    [readOnly]="
                      isViewMode || 
                      (!!editingTrainingTemplateId && isIntegrationLocationType)
                    "
                  >
                  </dx-autocomplete>
                </div>
              </dxi-item>
              <dxi-item
                *ngIf="
                  trainingTemplateForm.trainingLocation &&
                  trainingTemplateForm.trainingLocation.locationType === TrainingLocationType.Web
                "
                dataField="trainingLocation.location"
              >
                <dxo-label [text]="getTrainingLocationLabel"></dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="
                  trainingTemplateForm.trainingLocation &&
                  trainingTemplateForm.trainingLocation.locationType !== null
                "
                dataField="trainingLocation.suffix"
                editorType="dxTextArea"
                [editorOptions]="{
                  height: 100
                }"
              >
                <dxo-label [text]="getTrainingLocationDetailsLabel"></dxo-label>
              </dxi-item>
            </dx-form>
          </div>
          <div class="col-md-12 col-lg-6">
            <div
              *ngIf="
                trainingTemplateForm.trainingLocation &&
                trainingTemplateForm.trainingLocation.locationType ==
                  TrainingLocationType.Address
              "
            >
              <ng-container
                *ngIf="
                  trainingTemplateForm.trainingLocation &&
                  trainingTemplateForm.trainingLocation.latitude &&
                  trainingTemplateForm.trainingLocation.longitude
                "
              >
                <app-google-maps
                  class="my-3"
                  [location]="trainingTemplateForm.trainingLocation"
                ></app-google-maps>
              </ng-container>
            </div>
          </div>
        </div>
      </app-panel>
    </div>
    <div>
      <app-panel
        *ngIf="
          trainingTemplateForm.trainingLocation &&
          trainingTemplateForm.trainingLocation.locationType ==
            TrainingLocationType.Address &&
          (!isViewMode || trainingTemplateForm.questions?.length)
        "
        class="participation-question-panel"
        [title]="'TRAINING-QUESTIONNAIRE.FORM.TITLE' | translate"
      >
        <app-edit-training-participation-questions
          #participationQuestionEditorComponent
          [isViewMode]="isViewMode"
          [templates]="questionTemplates"
          [questions]="trainingTemplateForm.questions ?? []"
          [disableDateSelection]="true"
        ></app-edit-training-participation-questions>
      </app-panel>
      <app-panel
        *ngIf="!isExternalEvent"
        [title]="'TRAINING-TEMPLATE.FORM.STANDARD-INVITATION-TEXT' | translate"
      >
        <dx-form
          labelLocation="top"
          [showColonAfterLabel]="false"
          [formData]="trainingTemplateForm"
        >
          <dxi-item
            *ngIf="!isViewMode"
            dataField="emailBody"
            label=""
            editorType="dxHtmlEditor"
            [editorOptions]="{
              label: '',
              height: 350,
              toolbar: {
                items: [
                  'undo',
                  'redo',
                  'separator',
                  {
                    name: 'size',
                    acceptedValues: ['8pt', '10pt', '12pt', '14pt', '18pt']
                  },
                  { name: 'font', acceptedValues: ['Arial'] },
                  'separator',
                  'bold',
                  'italic',
                  'strike',
                  'underline',
                  'separator',
                  'alignLeft',
                  'alignCenter',
                  'alignRight',
                  'alignJustify',
                  'separator',
                  'orderedList',
                  'bulletList',
                  'separator',
                  {
                    name: 'header',
                    acceptedValues: [false, 1, 2, 3, 4, 5]
                  },
                  'separator',
                  'background',
                  'separator',
                  'link'
                ]
              }
            }"
          >
            <dxo-label text=" "></dxo-label>
          </dxi-item>
          <dxi-item
            *ngIf="isViewMode"
            dataField="emailBody"
            label=""
            editorType="dxHtmlEditor"
            [editorOptions]="{
              label: '',
              height: 350,
              readOnly: isViewMode
            }"
          >
            <dxo-label text=" "></dxo-label>
          </dxi-item>
        </dx-form>
        <div 
          *ngIf="userContext.canUseTextTemplates"
          class="text-template-container"
        >
          <app-text-template-selector
            *ngIf="!isViewMode"
            [type]="invitationTextTemplateType"
            [content]="trainingTemplateForm.emailBody"
            (contentChange)="onEmailBodyContentChanged($event)"
          ></app-text-template-selector>
        </div>
      </app-panel>
    </div>
  </app-page>
</div>

@if(showPreviewReportViewer) {
  <app-report-viewer-modal
    [title]="trainingTemplateForm.name"
    [(showModal)]="showPreviewReportViewer"
    [reportUrl]="reportUrl"
  ></app-report-viewer-modal>
}

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteTemplateModal"
  (submit)="onDeleteTemplateClick()"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>